import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQueryWithReauth } from 'api/api.config';

export const tagRulesAPI = createApi({
	reducerPath: 'tagRulesAPI',
	baseQuery: baseQueryWithReauth,
	endpoints: (build) => ({
		// Проверяет все правила пользователя. Циклические зависимости
		getTagRulesCheck: build.query({
			query: () => ({
				url: '/tag_rules_dep_check/',
			}),
		}),
	}),
});
